<style>
  .Men {
    background-color: #7bd5dd !important;
  }

  .Women {
    background-color: #e86c37 !important;
  }
</style>

<h5 *ngIf="KarshnasMasolForm_Edit_Id==-1"> Responsible Technician Information </h5>
<h5 *ngIf="KarshnasMasolForm_Edit_Id>-1"> Edit Responsible Technician </h5>

<form [formGroup]="RabetMasolCustomer" (submit)="OnSubmit_KarshnasMasolForm()">

  <input type="hidden" formControlName="id">

  <div class="row">
    <div class="form-group col-md-3">
      <label for="exampleInputEmail1"> Name (*) </label>
      <input formControlName="FName" type="text" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_FName().valid && get_Form_RabetMasol_FName().touched"
        class="form-text text-muted MyErrorRedColor">Enter the first name.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1"> Last Name (*) </label>
      <input formControlName="LName" type="text" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_LName().valid && get_Form_RabetMasol_LName().touched"
        class="form-text text-muted MyErrorRedColor">Enter the last name.</small>
    </div>


    <div class="form-group col-md-3" *ngIf="!Shitch_KarshnasType">
      <label for="exampleInputEmail1">
        <button type="button" (click)="Shitch_KarshnasType_click()" class="btn btn-secondary">
          Position (click to select)
        </button>
      </label>
      <input formControlName="Semat" type="text" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_Semat().valid && get_Form_RabetMasol_Semat().touched"
        class="form-text text-muted MyErrorRedColor">Enter the position.</small>
    </div>

    <div class="form-group col-md-3" *ngIf="Shitch_KarshnasType">
      <label for="exampleInputEmail1">
        <button type="button" (click)="Shitch_KarshnasType_click()" class="btn btn-secondary">
          Position (click to type)
        </button>
      </label>
      <select class="custom-select" formControlName="Semat">
        <option value="">Select</option>
        <option *ngFor="let item of DataList_Semat" [value]="item.title">{{item.title}}</option>
      </select>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">Gender</label>
      <select formControlName="Sex" class="custom-select">
        <option value="0">Female</option>
        <option value="1">Male</option>
      </select>
    </div>


  </div>

  <div class="row">


    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        Phone
        <button (click)="OnAdd_RabetMasolCustomer_Tel()" type="button"
          [disabled]="!get_Form_RabetMasol_Tel().valid || get_Form_RabetMasol_Tel().value =='' || get_Form_RabetMasol_Mobile().value == null "
          class="btn  btn-success"><i class="fa  fa-plus-circle"></i> </button>
      </label>
      <input type="number" formControlName="Tel" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_Tel().valid && get_Form_RabetMasol_Tel().touched"
        class="form-text text-muted MyErrorRedColor">Enter the phone number.</small>

      <table class="mb-0 table table-bordered table-3 text-center table-striped"
        *ngIf="RabetMasolCustomer_Tel.length>0">
        <tr class="bg-warning" *ngFor="let item of RabetMasolCustomer_Tel">
          <td>
            {{item.title}}
          </td>
          <td>
            <a style="cursor: pointer;" (click)="RabetMasolCustomer_Tel_Delete(item.id)"><i class="fa fa-remove"></i>
              Delete </a>
          </td>
        </tr>
      </table>

    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        Primary Mobile (without leading zero)
      </label>
      <input type="number" formControlName="Mobile" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_Mobile().valid && get_Form_RabetMasol_Mobile().touched"
        class="form-text text-muted MyErrorRedColor">Enter the primary mobile number.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        Alternate Mobile (without leading zero)
      </label>
      <input type="number" formControlName="jaygozinMiblie" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_jaygozinMiblie().valid && get_Form_RabetMasol_jaygozinMiblie().touched"
        class="form-text text-muted MyErrorRedColor">Enter the alternate mobile number.</small>
    </div>

    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">
        Messaging Mobile (without leading zero)
      </label>
      <input type="number" formControlName="majaziMobile" class="form-control" placeholder="Type here...">
      <small *ngIf="!get_Form_RabetMasol_majaziMobile().valid && get_Form_RabetMasol_majaziMobile().touched"
        class="form-text text-muted MyErrorRedColor">Enter the messaging mobile number.</small>
    </div>

  </div>

  <div class="row">
    <div class="form-group col-md-3">
      <label for="exampleInputEmail1">SMS</label>
      <select formControlName="SmsActive" class="custom-select">
        <option value="0"> Do Not Send</option>
        <option value="1"> Send</option>
      </select>

    </div>
    <div class="form-group col-md-9">
      <label for="exampleInputEmail1"> Description </label>
      <input type="text" formControlName="Dsc" class="form-control" placeholder="Type here...">
    </div>
  </div>


  <button *ngIf="KarshnasMasolForm_Edit_Id==-1" type="submit" [disabled]="!RabetMasolCustomer.valid"
    class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Responsible Technician
  </button>
  <button *ngIf="KarshnasMasolForm_Edit_Id==-1" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i
      class="fa fa-times-rectangle"></i> Cancel </button>

  <button *ngIf="KarshnasMasolForm_Edit_Id>-1" type="submit" [disabled]="!RabetMasolCustomer.valid" class="btn btn-info"
    style="margin-right: 5px;"><i class="fa  fa-edit"></i> Edit Responsible Technician </button>
  <button *ngIf="KarshnasMasolForm_Edit_Id>-1" type="button" (click)="KarshnasMasolForm_Edit_Cancel()"
    class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle"></i> Cancel Editing </button>

</form>

<br />
<br />

<div class="table-responsive" *ngIf="DataList_KarshnasMasol.length>0 && KarshnasMasolForm_Edit_Id==-1">
  <table class="mb-0 table table-bordered table-3 text-center table-striped">
    <thead style="background-color: #489b39; color: white;">
      <tr>
        <th>#</th>
        <th>SMS</th>
        <th>Name</th>
        <th>Last Name</th>
        <th>Gender</th>
        <th>Position</th>
        <th>Phone</th>
        <th>Primary Mobile</th>
        <th>Alternate Mobile</th>
        <th>Messaging Mobile</th>
        <th>Description</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_KarshnasMasol" [ngClass]="{'Men': item.sex===1,'Women': item.sex===0}">
        <td>{{DataList_KarshnasMasol.indexOf(item)+1}}</td>
        <td>
          <input type="checkbox" disabled="" [(ngModel)]="item.smsActive" />
        </td>
        <td>{{item.fname}}</td>
        <td>{{item.lname}}</td>
        <td>
          <p *ngIf="item.sex==0">Female</p>
          <p *ngIf="item.sex==1">Male</p>
        </td>
        <td>{{item.semat}}</td>

        <td>
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <tr style="background-color: #accba7;" *ngFor="let itemDetail of item.Tel">
              <td>
                {{item.Tel.indexOf(itemDetail)+1}}
              </td>
              <td>
                {{itemDetail.title}}
              </td>
            </tr>
          </table>
        </td>
        <td>{{item.mobile}}</td>
        <td>{{item.jaygozinMiblie}}</td>
        <td>{{item.majaziMobile}}</td>
        <td>{{item.dsc}} </td>
        <td>
          <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
            <div class="btn-group" role="group">
              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Actions
              </button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a style="cursor: pointer;" (click)="KarshnasMasolForm_Edit(DataList_KarshnasMasol.indexOf(item))"
                  class="dropdown-item"><i class="fa fa-edit"></i> Edit </a>

                <a style="cursor: pointer;" (click)="KarshnasMasolForm_Delete(DataList_KarshnasMasol.indexOf(item))"
                  class="dropdown-item"><i class="fa fa-remove"></i> Delete </a>
              </div>
            </div>
          </div>
        </td>

      </tr>
    </tbody>
  </table>
</div>

<br />